<template>
  <div class="mx-4 my-4 md:mx-8">
    <h1 class="text-3xl mb-5 ml-3">Criar acesso plataforma</h1>

    <div class="mt-5 md:mt-0 md:col-span-2">
      <form action="#" method="POST" autocomplete="off">
        <div class="px-5 pb-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 md:col-span-4">
              <label for="name" class="block text-sm font-medium">
                Nome <span class="text-red-600">*</span>
              </label>
              <input
                v-model="form.nome"
                type="text"
                name="name"
                id="name"
                placeholder="Digite o nome do cliente"
                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div class="col-span-12 md:col-span-4">
              <label for="email" class="block text-sm font-medium">
                Email <span class="text-red-600">*</span>
              </label>
              <input
                v-model="form.email"
                type="text"
                name="email"
                id="email"
                placeholder="Digite o email de acesso"
                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div class="col-span-12 md:col-span-4">
              <label for="centrocusto" class="block text-sm font-medium">Centro de Custo</label>
              <input
                v-model="form.centrocusto"
                type="text"
                name="centrocusto"
                id="centrocusto"
                placeholder="Digite o centro de custo caso necessário"
                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div class="grid grid-cols-12 gap-6 mt-3">
            <div class="col-span-12 md:col-span-4">
              <label for="password" class="block text-sm font-medium">
                Senha <span class="text-red-600">*</span>
              </label>
              <div class="relative mt-1">
                <input
                  autocomplete="new-password"
                  v-model="form.password"
                  :type="mostrarSenha ? 'text' : 'password'"
                  name="password"
                  id="password"
                  placeholder="Digite a senha inicial"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-11 shadow-sm sm:text-sm border-gray-300 rounded-md"
                />
                <button type="button" @click="mostrarSenha = !mostrarSenha" class="absolute inset-y-0 right-3 flex items-center text-gray-300 transition hover:text-gray-500">
                  <svg v-if="!mostrarSenha" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7Z" />
                  </svg>

                  <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3l18 18" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.584 10.587A2 2 0 0012 14a2 2 0 001.414-.586" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.879 5.583A10.01 10.01 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.964 9.964 0 01-2.043 3.368M6.228 6.228C4.521 7.352 3.229 9.015 2.458 12c1.274 4.057 5.065 7 9.542 7a9.98 9.98 0 004.132-.892" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="col-span-12 md:col-span-4">
              <label for="password2" class="block text-sm font-medium">
                Confirme a senha <span class="text-red-600">*</span>
              </label>
              <div class="relative mt-1">
                <input
                  autocomplete="new-password"
                  v-model="form.password2"
                  :type="mostrarSenha ? 'text' : 'password'"
                  name="password2"
                  id="password2"
                  placeholder="Confirme a senha inicial"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-11 shadow-sm sm:text-sm border-gray-300 rounded-md"
                />
                <button type="button" @click="mostrarSenha = !mostrarSenha" class="absolute inset-y-0 right-3 flex items-center text-gray-300 transition hover:text-gray-500">
                  <svg v-if="!mostrarSenha" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7Z" />
                  </svg>

                  <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3l18 18" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.584 10.587A2 2 0 0012 14a2 2 0 001.414-.586" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.879 5.583A10.01 10.01 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.964 9.964 0 01-2.043 3.368M6.228 6.228C4.521 7.352 3.229 9.015 2.458 12c1.274 4.057 5.065 7 9.542 7a9.98 9.98 0 004.132-.892" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="col-span-12 md:col-span-4">
              <label for="emailNotification" class="block text-sm font-medium">
                E-mail de notificações
              </label>
              <input
                v-model="form.emailNotification"
                type="email"
                name="emailNotification"
                id="emailNotification"
                placeholder="E-mail para avisos de campanhas e validações"
                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <hr class="mt-6 mb-3" />
          <h3 class="font-semibold text-lg mb-3">Acessos conversas</h3>
          <div class="grid grid-cols-12 gap-6">
            <div
              class="col-span-12 md:col-span-12"
            >
              <label for="ativarRespostas" class="block text-sm font-medium">
                <input
                  type="checkbox"
                  v-model="form.ativarRespostas"
                  class="rounded-sm"
                />
                <span class="ml-2">
                  Liberar tela de resposta para acompanhamento
                </span>
              </label>
            </div>
          </div>
          <hr class="mt-6 mb-3" />
          <h3 class="font-semibold text-lg mb-3">Saldo</h3>
          <div class="grid grid-cols-12 gap-6">
            <div class="col-span-12 md:col-span-12">
              <label for="saldoIlimitado" class="block text-sm font-medium">
                <input
                  type="checkbox"
                  id="saldoIlimitado"
                  v-model="form.saldoIlimitado"
                  class="rounded-sm"
                />
                <span class="ml-2">
                  Envios ilimitados (sem controle de saldo pré-pago)
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 grap-6">
          <div class="px-5 py-3">
            <button
              @click="save"
              type="button"
              class="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:bg-green-400"
            >
              Salvar
            </button>
          </div>
        </div>
      </form>
      <GerenciadorSaldoParceiro parceiro="bluesend" />
    </div>
  </div>
</template>

<script>
import GerenciadorSaldoParceiro from "../../components/GerenciadorSaldoParceiro.vue";

export default {
  components: { GerenciadorSaldoParceiro },
  data() {
    return {
      mostrarSenha: false,
      form: {
        nome: "",
        email: "",
        centrocusto: "",
        password: "",
        password2: "",
        emailNotification: "",
        ativarRespostas: false,
        saldoIlimitado: false,
      },
    };
  },

  methods: {
    async save() {
      if (!this.form.nome || !this.form.email || !this.form.password) {
        return this.$vToastify.error("Digite o nome, email e senha");
      }

      if (this.form.password2 !== this.form.password) {
        return this.$vToastify.error("Senha e confirmação são diferentes");
      }

      const emailNotification = String(this.form.emailNotification || "").trim();
      if (emailNotification && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailNotification)) {
        return this.$vToastify.error("Informe um e-mail de notificações válido");
      }

      this.form.emailNotification = emailNotification;

      const req = await this.$http.post(`/criarContaBluesend`, this.form);

      if (req.data.success) {
        this.$vToastify.success("Conta criada com sucesso!");
        this.form = {
            nome: "",
            email: "",
            centrocusto: "",
            password: "",
            password2: "",
            emailNotification: "",
            ativarRespostas: false,
            saldoIlimitado: false,
        };
        this.mostrarSenha = false;
      } else {
        this.$vToastify.error(req.data.err);
      }
    },
  },
};
</script>
